import { _mock } from './_mock';

// ----------------------------------------------------------------------

export const _carouselsMembers = [...Array(6)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.fullName(index),
  role: _mock.role(index),
  avatarUrl: _mock.image.portrait(index),
}));

export const carouselMembers = [
  {
    id: 1,
    name: 'Lukman Al-Busaidi',
    role: 'CTO',
    avatarUrl: '/assets/images/about/portrait.jpg',
    socials: [
      {
        value: 'instagram',
        name: 'Instagram',
        icon: 'ant-design:instagram-filled',
        color: '#E02D69',
        path: 'https://www.instagram.com/lsk.14?igsh=MTFqMzNwazg2bmJqeA==',
      },
      {
        value: 'linkedin',
        name: 'Linkedin',
        icon: 'eva:linkedin-fill',
        color: '#007EBB',
        path: 'https://www.linkedin.com/in/lukman-al-busaidi-7384a1204',
      },
    ],
  },
  {
    id: 2,
    name: 'Khalfan Al-Busaidi',
    role: 'Project Manager',
    avatarUrl: '/assets/images/about/portrait.jpg',
    socials: [
      {
        value: 'instagram',
        name: 'Instagram',
        icon: 'ant-design:instagram-filled',
        color: '#E02D69',
        path: 'https://www.instagram.com/kalvin.albusaidi?igsh=MXR1eHN3ZWZwenE0aQ==',
      },
      {
        value: 'linkedin',
        name: 'Linkedin',
        icon: 'eva:linkedin-fill',
        color: '#007EBB',
        path: 'https://www.linkedin.com/in/khalfan-al-busaidi-b1ba76192?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
      },
    ],
  },
];

// ----------------------------------------------------------------------

export const _faqs = [...Array(8)].map((_, index) => ({
  id: _mock.id(index),
  value: `panel${index + 1}`,
  heading: `Questions ${index + 1}`,
  detail: _mock.description(index),
}));

export const faqs = [
  {
    id: 'will-i-be-needing-help-to-start-using-Eiadati?',
    value: 'panel1',
    heading: 'Will I be needing help to start using Eiadati?',
    detail:
      'Probably not. We’ve designed our practice management software to be simple and intuitive to use from day one. If you do run into problems, we’ll always be here to offer email support – all included in your monthly subscription.',
  },
  {
    id: 'I already have a management system now, Can I switch to Eiadati?',
    value: 'panel2',
    heading: 'I already have a management system now, Can I switch to Eiadati?',
    detail:
      "Yes, many oraganizations have done just that. Easiest and most straightforward method is to register all new patients and appointments on Eiadati and enter inforamation as needed and required. Importing existing patient demographics should be possible but with structured files with disparate information. This can all be done with the 'import' icon next to each table.",
  },
  {
    id: 'Can I share my user account to others?',
    value: 'panel3',
    heading: 'Can I share my user account to others?',
    detail:
      "No, this is not an acceptable practice! With a shared account, you wouldn’t be able to identify any changes made by different users for auditing and data protection purposes. Under our privacy policies and terms conditions, this practise is considered 'Pohibited Activities'.",
  },
  {
    id: 'How can I manage my account?',
    value: 'panel4',
    heading: 'How can I manage my account?',
    detail:
      "You can easily do that by first logging in and from there, clicking on 'My Account' button, if you wish to subscribe, you can easily do that from the home screen or under billing section in you account page.",
  },
  {
    id: 'Is Eiadati compliant with healthcare regulations?',
    value: 'panel5',
    heading: 'Is Eiadati compliant with healthcare regulations?',
    detail:
      'Yes, a reputable Eiadati is designed to adhere to healthcare regulations, such as HIPAA (Health Insurance Portability and Accountability Act) in the United States, ensuring the security and privacy of patient information.',
  },
  {
    id: 'How can I pay for Eiadati services?',
    value: 'panel6',
    heading: 'How can I pay for Eiadati services?',
    detail:
      'When navigating to the payment page, from there, you can choose to pay with your card (Visa, Mastercard), Google pay or Apple pay, whatever suits you the most. You can choose the package you like the most and proceed from there.',
  },
  {
    id: 'Will Eiadati work outside of MiddleEast?',
    value: 'panel7',
    heading: 'Will Eiadati work outside of MiddleEast?',
    detail:
      'Yes! The UI elements are in English, so lang as you can use that, no issues. You can even capture your clinical data using localised keyboard in a different language. We might localise the app for other regions based on demand. You will be billed in OMR when you are ready to convert to a paid account. You must check your local policies regarding data localisation.',
  },
  {
    id: 'Is my data secured?',
    value: 'panel8',
    heading: 'Is my data secured?',
    detail:
      "We are doing our best to keep everything safe and well secured. To know more about this, look at our 'Privacy Policy' page.",
  },
  {
    id: 'Who can use Eiadati?',
    value: 'panel9',
    heading: 'Who can use Eiadati?',
    detail:
      'Eiadati is meant for people over 18 years old, and in perticualr, clinicians and doctors. Thus, hospitals, clincis and medical sectors and utilize the platform. Of course, payment is requried before fully using it.',
  },
  {
    id: 'Can I get my money back after paying?',
    value: 'panel10',
    heading: 'Can I get my money back after paying?',
    detail:
      'After paying for the subscription, it is unfortunately not possible to refund your money, however, the benifits that comes with the package chosen will only be expired after the billing date expires.',
  },
];

// ----------------------------------------------------------------------

export const _addressBooks = [...Array(24)].map((_, index) => ({
  id: _mock.id(index),
  primary: index === 0,
  name: _mock.fullName(index),
  email: _mock.email(index + 1),
  fullAddress: _mock.fullAddress(index),
  phoneNumber: _mock.phoneNumber(index),
  company: _mock.companyName(index + 1),
  addressType: index === 0 ? 'Home' : 'Office',
}));

// ----------------------------------------------------------------------

export const _contacts = [...Array(20)].map((_, index) => {
  const status =
    (index % 2 && 'online') || (index % 3 && 'offline') || (index % 4 && 'alway') || 'busy';

  return {
    id: _mock.id(index),
    status,
    role: _mock.role(index),
    email: _mock.email(index),
    name: _mock.fullName(index),
    phoneNumber: _mock.phoneNumber(index),
    lastActivity: _mock.time(index),
    avatarUrl: _mock.image.avatar(index),
    address: _mock.fullAddress(index),
  };
});

// ----------------------------------------------------------------------

export const _notifications = [...Array(9)].map((_, index) => ({
  id: _mock.id(index),
  avatarUrl: [
    _mock.image.avatar(1),
    _mock.image.avatar(2),
    _mock.image.avatar(3),
    _mock.image.avatar(4),
    _mock.image.avatar(5),
    null,
    null,
    null,
    null,
    null,
  ][index],
  type: ['friend', 'project', 'file', 'tags', 'payment', 'order', 'chat', 'mail', 'delivery'][
    index
  ],
  category: [
    'Communication',
    'Project UI',
    'File Manager',
    'File Manager',
    'File Manager',
    'Order',
    'Order',
    'Communication',
    'Communication',
  ][index],
  isUnRead: _mock.boolean(index),
  createdAt: _mock.time(index),
  title:
    (index === 0 && `<p><strong>Deja Brady</strong> sent you a friend request</p>`) ||
    (index === 1 &&
      `<p><strong>Jayvon Hull</strong> mentioned you in <strong><a href='#'>Minimal UI</a></strong></p>`) ||
    (index === 2 &&
      `<p><strong>Lainey Davidson</strong> added file to <strong><a href='#'>File Manager</a></strong></p>`) ||
    (index === 3 &&
      `<p><strong>Angelique Morse</strong> added new tags to <strong><a href='#'>File Manager<a/></strong></p>`) ||
    (index === 4 &&
      `<p><strong>Giana Brandt</strong> request a payment of <strong>$200</strong></p>`) ||
    (index === 5 && `<p>Your order is placed waiting for shipping</p>`) ||
    (index === 6 && `<p>Delivery processing your order is being shipped</p>`) ||
    (index === 7 && `<p>You have new message 5 unread messages</p>`) ||
    (index === 8 && `<p>You have new mail`) ||
    '',
}));

// ----------------------------------------------------------------------

export const _mapContact = [
  {
    latlng: [23.5111, 58.4516],
    address: 'AlAmerat, Muscat, Oman',
    phoneNumber: "+31645724500",
  },
];

// ----------------------------------------------------------------------

export const _socials = [
  {
    value: 'facebook',
    name: 'FaceBook',
    icon: 'eva:facebook-fill',
    color: '#1877F2',
    path: 'https://www.facebook.com/caitlyn.kerluke',
  },
  {
    value: 'instagram',
    name: 'Instagram',
    icon: 'ant-design:instagram-filled',
    color: '#E02D69',
    path: 'https://www.instagram.com/caitlyn.kerluke',
  },
  {
    value: 'linkedin',
    name: 'Linkedin',
    icon: 'eva:linkedin-fill',
    color: '#007EBB',
    path: 'https://www.linkedin.com/caitlyn.kerluke',
  },
  {
    value: 'twitter',
    name: 'Twitter',
    icon: 'eva:twitter-fill',
    color: '#00AAEC',
    path: 'https://www.twitter.com/caitlyn.kerluke',
  },
];

export const socials = [
  {
    value: 'instagram',
    name: 'Instagram',
    icon: 'ant-design:instagram-filled',
    color: '#E02D69',
    path: 'https://www.instagram.com/eiadati.om?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
  },
];

// ----------------------------------------------------------------------

export const _homePlans = [...Array(3)].map((_, index) => ({
  license: ['Basic', 'Premium', 'Enterprise'][index],
  commons: ['One end products', '12 months updates', '6 months of support'],
  options: [
    'JavaScript version',
    'TypeScript version',
    'Design Resources',
    'Commercial applications',
  ],
  icons: [
    '/assets/icons/platforms/ic_js.svg',
    '/assets/icons/platforms/ic_ts.svg',
    '/assets/icons/platforms/ic_figma.svg',
  ],
}));

// ----------------------------------------------------------------------

export const _pricingPlans = [
  {
    subscription: 'basic',
    price: 0,
    caption: 'Forever',
    lists: ['3 Prototypes', '3 Boards', 'Up To 5 Team Members'],
    labelAction: 'Current Plan',
  },
  {
    subscription: 'starter',
    price: 4.99,
    caption: 'Saving $24 a year',
    lists: [
      '3 Prototypes',
      '3 Boards',
      'Up To 5 Team Members',
      'Advanced Security',
      'Issue Escalation',
    ],
    labelAction: 'Choose Starter',
  },
  {
    subscription: 'premium',
    price: 9.99,
    caption: 'Saving $124 a year',
    lists: [
      '3 Prototypes',
      '3 Boards',
      'Up To 5 Team Members',
      'Advanced Security',
      'Issue Escalation',
      'Issue Development license',
      'Permissions & workflows',
    ],
    labelAction: 'Choose Premium',
  },
];

// ----------------------------------------------------------------------

export const _testimonials = [
  {
    name: _mock.fullName(1),
    postedDate: _mock.time(1),
    ratingNumber: _mock.number.rating(1),
    avatarUrl: _mock.image.avatar(1),
    content: `Excellent Work! Thanks a lot!`,
  },
  {
    name: _mock.fullName(2),
    postedDate: _mock.time(2),
    ratingNumber: _mock.number.rating(2),
    avatarUrl: _mock.image.avatar(2),
    content: `It's a very good dashboard and we are really liking the product . We've done some things, like migrate to TS and implementing a react useContext api, to fit our job methodology but the product is one of the best in terms of design and application architecture. The team did a really good job.`,
  },
  {
    name: _mock.fullName(3),
    postedDate: _mock.time(3),
    ratingNumber: _mock.number.rating(3),
    avatarUrl: _mock.image.avatar(3),
    content: `Customer support is realy fast and helpful the desgin of this theme is looks amazing also the code is very clean and readble realy good job !`,
  },
  {
    name: _mock.fullName(4),
    postedDate: _mock.time(4),
    ratingNumber: _mock.number.rating(4),
    avatarUrl: _mock.image.avatar(4),
    content: `Amazing, really good code quality and gives you a lot of examples for implementations.`,
  },
  {
    name: _mock.fullName(5),
    postedDate: _mock.time(5),
    ratingNumber: _mock.number.rating(5),
    avatarUrl: _mock.image.avatar(5),
    content: `Got a few questions after purchasing the product. The owner responded very fast and very helpfull. Overall the code is excellent and works very good. 5/5 stars!`,
  },
  {
    name: _mock.fullName(6),
    postedDate: _mock.time(6),
    ratingNumber: _mock.number.rating(6),
    avatarUrl: _mock.image.avatar(6),
    content: `CEO of Codealy.io here. We’ve built a developer assessment platform that makes sense - tasks are based on git repositories and run in virtual machines. We automate the pain points - storing candidates code, running it and sharing test results with the whole team, remotely. Bought this template as we need to provide an awesome dashboard for our early customers. I am super happy with purchase. The code is just as good as the design. Thanks!`,
  },
];
